module.exports = __webpack_public_path__ + "img/sg.3d05a02d.svg";